import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Legal() {
  const loc = useLocation();
  const isTerms = loc.pathname.includes("terms");
  const key = isTerms ? "legal_terms" : "legal_privacy";
  const [content, setContent] = useState(null);
  useEffect(() => { api.get("/content").then((r) => setContent(r.data)).catch(() => {}); }, []);
  const d = content?.[key];
  const fallbackTitle = isTerms ? "Terms & Conditions" : "Privacy Policy";

  return (
    <div>
      <Header />
      <section className="bg-navy text-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="font-display font-bold text-4xl tracking-tight">{d?.title || fallbackTitle}</h1>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          {content && (d?.enabled === false ? (
            <p className="text-slate-500" data-testid="legal-unavailable">This page is currently unavailable.</p>
          ) : (
            <div className="text-slate-700 whitespace-pre-line leading-relaxed" data-testid="legal-body">{d?.body}</div>
          ))}
        </div>
      </section>
      <Footer content={content} />
    </div>
  );
}
